var config = {
     HOST: 'https://mapi.ekrushi.com/',
    //HOST: 'http://localhost:4000/',
}

var auth = {
    AUTH_TOKEN: ''
}

var api = {
    // LOGIN (DESIGN-REDUCERS)
    POST_LOGIN: 'society-login',
    POST_MOBILE_NUMBER: 'mobileVerify',
    POST_OTP: 'otpVerify',
    CHANGE_PASS: 'changePass',
    HELP: 'help',

    // uplaod file/photo
    UPLOAD: 'upload-image',
    UPLOAD_FILES: 'upload-document',

    //SH (PROFILE-REDUCER)
    GET_SH_PROFILE: 'registration/addedby/',
    SACHIV: 'registration',

    // SO (DIERCTOR-TABLE-REDUCER)
    GET_SO_DIRECTOR_PROFILE: 'directorList',
    SO_DIRECTOR: 'director',
    SEARCH_DIRECTOR: 'search-director',

    /**SOCIETY DASHBOARD ONLY */
    SOC_DASHBOARD: 'soc-dir-mem-count',

    // SO (SO-MEMBER-REDUCER)
    GET_SO_MEMBER_PROFILE: 'memberBySocietyId/',
    SO_MEMBER: 'member',
    SEARCH_MEMBER: 'search-member',

    // SO (BRANCH-TABLE-REDUCER)
    GET_SO_SOCIETY_TYPES: 'societyType/',
    SO_SOCIETY: 'society',
    SOCIETY: 'societyDetails',
    SOCIETY_LIST_BY_TYPE: 'socBySocietyType',

    // SO (HOMEIMG-REDUCER)
    POST_HOME_IMGS: 'homeImg',

    // SO (GALLERY-REDUCER)
    ALBUM: 'album',
    GALLERY: 'gallery',
    // SO ABOUT US API (ABOUT-REDUCER)
    POST_ABOUT_US: 'aboutUs',
    DELETE_ABOUT_US: 'about/',
    GET_ABOUTUS: 'aboutUsBySocietyId/',

    GET_HOME_IMG: 'homeImg/societyId/',

    GET_SOC_INTERNAL_NOTIFICATION: 'get-society-internal-notification',
    ADD_SOC_INTERNAL_NOTIFICATION: 'add-internal-notification',
    UPDATE_SOC_INTERNAL_NOTIFICATION: 'update-internal-notification',
    DELETE_SOC_INTERNAL_NOTIFICATION: 'delete-internal-notification',
}

module.exports = { config, api, auth }



// WEBPACK FOOTER //
// ./src/configs/constants.js